import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import { RowDataLive } from 'src/reducers/liveorderfile';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconButton } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import { RowDataManufactur } from 'src/reducers/manufactur';

interface TableState {
    columns: Array<Column<RowDataManufactur>>;
    data: RowDataManufactur[];
}

export interface UserDesignViewProps {
    underDesignData: RowDataManufactur[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;

}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        '& .MuiTableCell-root': {
            padding: '5px 16px'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        }
    })
);

const UserDesignView: React.StatelessComponent<UserDesignViewProps> = (props) => {
    console.log(props, 'aaaaaaaaaaaaaaaa'); 
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Case No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            //  {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '8px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Customer Name',
                field: 'customername',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Uploaded On',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Status',
                field: 'customerstatus',
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                },
                render: rowData => (
                    <div>
                        {rowData.customerstatus === 'Created' ? <div style={{ color: 'red' }}><b>Order Created</b></div> : null}
                        {rowData.customerstatus === 'Accepted' ? <div style={{ color: 'blue' }}><b>Order Accepted</b></div> : null}
                        {rowData.customerstatus === 'In Progress' ? <div style={{ color: 'violet' }}><b>In Progress</b></div> : null}
                    </div>
                ),
                lookup:
                {
                    'Created': 'Order Created',
                    'Accepted': 'Order Accepted',
                    'In Progress': 'In Progress',
                }
            },
            {
                title: 'Action',
                field: 'orderno',
                filtering: false,
                export: false,
                render: rowData => (
                    <div style={{ margin: 'auto' }}>
                        <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                        <IconButton aria-label="view" onClick={() => props.onDownloadClick((JSON.parse(JSON.stringify(rowData)).fpath), (JSON.parse(JSON.stringify(rowData)).fname))}>
                            <CloudDownloadIcon fontSize="small" />
                        </IconButton>
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            },
        ],
        data: props.underDesignData
    });
    const classes = useStyles({});
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                            <AutorenewIcon />
                        </Fab>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Design In Progress"
                        columns={state.columns}
                        data={props.underDesignData}
                        localization={{
                            toolbar: {
                                nRowsSelected: '{0} order(s) selected',
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        options={{
                            filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            sorting: true,
                            actionsColumnIndex: -1,
                            exportButton: true,
                            exportAllData: true,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '10px',
                                textAlign: 'center'
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default UserDesignView;



// WEBPACK FOOTER //
// ./src/components/layouts/UnderDesignView.tsx